export default __webpack_public_path__ + "img/component-info-2.5cc4b2f9.png";